<script lang="ts" setup>
withDefaults(
  defineProps<{
    centerContent?: "horizontal" | "vertical" | "both";
  }>(),
  {
    centerContent: "horizontal",
  },
);
</script>

<template>
  <div
    class="column-layout-box"
    :data-center-content="centerContent"
  >
    <div class="column-layout-box--content">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
@import "ColumnLayoutBox.css";
</style>
